import React, { useEffect, useState } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Col, InputGroup, Form } from "react-bootstrap";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import { CHECKOUT_REMOVE_POINT, CHECKOUT_REMOVE_VOUCHER } from "@components/pages/CheckoutPage/queries";
import { checkoutRemovePoint } from "@components/pages/CheckoutPage/__generated__/checkoutRemovePoint";
import { checkoutRemoveVoucher } from "@components/pages/CheckoutPage/__generated__/checkoutRemoveVoucher";
import { gaV4GetItemsFromSingleProduct, gaV4ViewItem, getPrice } from "@utils";
import { useAlert } from "react-alert";
import { MyVoucherModal } from "@molecules/MyVoucherModal";
import {
  vouchers_availableVouchers,
  vouchers_availableVouchers_edges_node
} from "@molecules/MyVoucherModal/__generated__/vouchers";
import { MY_VOUCHER } from "@molecules/MyVoucherModal/queries";

const CheckoutDiscount: React.FC<IProps> = (
  {
    formik,
    checkout,
    setCheckout,
    codSelected,
    loading
  }: IProps) => {

  const alert = useAlert();
  const [showMyVoucherModal, setShowMyVoucherModal] = useState(false);
  const [checkoutRemovePoint, { data, error, loading: loadingPoint }] =
    useMutation<checkoutRemovePoint>(CHECKOUT_REMOVE_POINT, {
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        setCheckout({ ...data.checkoutRemovePoint.checkout });
        formik.setFieldValue("usedPoint", "");
      }
    });

  const handleClickRemovePoint = (e: any) => {
    e.preventDefault();
    checkoutRemovePoint({
      variables: { id: checkout.id }
    });
  };

  const [checkoutRemoveVoucher,
    { data: dataVoucher, error: errorVoucher, loading: loadingVoucher }] =
    useMutation<checkoutRemoveVoucher>(CHECKOUT_REMOVE_VOUCHER, {
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        setCheckout({ ...data.checkoutRemoveVoucher.checkout });
        formik.setFieldValue("voucherCode", "");
      }
    });

  const handleClickVoucher = (e: any) => {
    e.preventDefault();
    checkoutRemoveVoucher({
      variables: { id: checkout.id }
    });
  };

  const [loadingResult, setLoadingResult] = useState(false);
  useEffect(() => {
    setLoadingResult(loading || loadingPoint || loadingVoucher);
  }, [loading, loadingPoint, loadingVoucher]);

  const handleMyVoucherClose = () => {
    setShowMyVoucherModal(false);
  };

  const [myVouchers, setMyVouchers] = useState<vouchers_availableVouchers_edges_node[]>([]);

  const [fetchVoucher, {
    data: myVoucherData,
    error: myVoucherError,
    loading: myVoucherLoading
  }] = useLazyQuery<vouchers_availableVouchers>(
    MY_VOUCHER,
    {
      onCompleted: async (data) => {
        setMyVouchers(data["availableVouchers"].edges.map((item) => {
          return item.node;
        }));
        setShowMyVoucherModal(true);
      }
    }
  );

  const handleMyVoucherShow = () => {
    fetchVoucher();
  };

  const selectVoucherFromModal = (code) => {
    setShowMyVoucherModal(false);
    formik.values.voucherCode = code;
  }

  return checkout && (
    <>
      <MyVoucherModal
        show={showMyVoucherModal}
        onHide={handleMyVoucherClose}
        closeNotifyMe={false} forceCheckout={false}
        vouchers={myVouchers}
        selectVoucher={selectVoucherFromModal}
      />
      <form onSubmit={formik.handleSubmit}>
        <div className="accordion" id="accordionExample">
          <div className="card">
            <div className="card-header" id="headingOne">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block" type="button" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                  style={{ textTransform: "uppercase", fontWeight: 700, color: "black", padding: 0 }}
                >
                  Step3 : Apply Extra Discount
                </button>
              </h2>
            </div>

            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne"
              data-parent="#accordionExample">
              <div className="card-body">
                <Container>
                  {
                    !codSelected &&
                    <S.InputGroupRow>
                      <Col md={4} xs={4}>
                        <S.FormLabel>POINTS</S.FormLabel>
                      </Col>
                      <Col md={8} xs={8}>
                        <InputGroup>
                          <Form.Control
                            className="input-group-prepend"
                            type="number"
                            name="usedPoint"
                            onChange={formik.handleChange}
                            value={formik.values.usedPoint}
                            disabled={checkout?.usedPoint?.amount !== 0}
                          />
                          {checkout?.usedPoint?.amount === 0 ?
                            <button
                              type="submit"
                              className="btn btn-outline"
                              style={{ color: "#fd346a", borderColor: "#fd346a", zIndex: 1 }}
                              disabled={loadingResult || formik.errors.usedPoint} >
                              USE
                            </button>
                            :
                            <>
                              <button
                                onClick={handleClickRemovePoint}
                                style={{ color: "#fd346a", borderColor: "#fd346a", zIndex: 1 }}
                                className="btn btn-outline"
                                disabled={loadingResult}>
                                REMOVE
                              </button>
                            </>
                          }
                        </InputGroup>
                        {
                          checkout?.usedPoint?.amount === 0 ?
                            <S.PointGuideWrapper>
                              <S.PointGuideText>
                                {`You have ${getPrice(checkout?.user?.point?.availableAmount, false)} points`}
                              </S.PointGuideText>
                            </S.PointGuideWrapper>
                            :
                            <S.CODPointNotAvailableWrapper>
                              <S.CODPointNotAvailableText>
                                If you Redeem points, COD will not be applicable.
                              </S.CODPointNotAvailableText>
                            </S.CODPointNotAvailableWrapper>
                        }
                        {
                          formik?.errors?.usedPoint ?
                            <S.CODPointNotAvailableWrapper>
                              <S.CODPointNotAvailableText>
                                {formik?.errors?.usedPoint}
                              </S.CODPointNotAvailableText>
                            </S.CODPointNotAvailableWrapper> : null
                        }
                      </Col>
                    </S.InputGroupRow>
                  }
                  <S.InputGroupRow>
                    <Col md={4} xs={4}>
                      <S.FormLabel>VOUCHER</S.FormLabel>
                    </Col>
                    <Col md={8} xs={8}>
                      <InputGroup>
                        <Form.Control
                          className="input-group-prepend"
                          type="text"
                          name="voucherCode"
                          onChange={formik.handleChange}
                          value={formik.values.voucherCode}
                        />
                        {checkout?.discountAmount?.amount === 0 ?
                          <button
                            type="submit"
                            className="btn btn-outline"
                            style={{ color: "#fd346a", borderColor: "#fd346a", zIndex: 1 }}
                            disabled={loadingResult}
                          >
                            USE
                          </button>
                          :
                          <button
                            onClick={handleClickVoucher}
                            style={{ color: "#fd346a", borderColor: "#fd346a", zIndex: 1 }}
                            className="btn btn-outline"
                            disabled={loadingResult}
                          >
                            REMOVE
                          </button>
                        }
                      </InputGroup>
                      <S.VoucherGuideWrapper>
                        {checkout?.discountAmount?.amount === 0 ?
                          <S.VoucherGuideText onClick={handleMyVoucherShow} href="#">
                            My Vouchers
                          </S.VoucherGuideText>
                          : <></>
                        }
                      </S.VoucherGuideWrapper>
                    </Col>
                  </S.InputGroupRow>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  ) || null;
};

export { CheckoutDiscount };
